export { default } from './BancoDoAuto25';
